import { maxBy } from 'lodash';
import { createSelector } from 'reselect';

import { getTasks } from './index';

const lastActivityForLead = (lead, tasks) => maxBy(activitiesForLead(lead, tasks), 'completedAt');
const leadIsAssociatedWithTask = (lead, task) => (
  task.associatedModels.find(model => (
    model.associatedModelType === lead.contactType && model.associatedModelId === lead.contactId
  ))
);

export const getLeads = state => state.leads;
export const getLeadsMeta = state => state.leadsMeta;
export const getProject = state => state.project;
export const getPossibleLeadReferralSources = state => state.leadsOptions.selectOptions.referralSources;
export const getPossibleLeadStatuses = state => state.leadsOptions.selectOptions.statuses;
export const getSelectedLeads = state => state.selectedLeads;
export const isFetchingLeads = state => state.leads.fetching;
export const shouldFetchLeads = state => !state.leadsMeta?.loaded && !state.leads?.fetching;
export const tasksForLead = (lead, tasks) => {
  if (!tasks || tasks.fetching) return [];
  return tasks.filter(task => !task.completed && leadIsAssociatedWithTask(lead, task));
};

export const activitiesForLead = (lead, tasks) => {
  if (!tasks || tasks.fetching) return [];

  return tasks.filter(task => task.completed && leadIsAssociatedWithTask(lead, task));
};

export const getDecoratedLeads = createSelector(
  [getLeads, getTasks],
  (leads, tasks) => {
    // Before the first fetch resolves, `state.leads` is the initial reducer object ({})
    // or the fetching placeholder ({ fetching: true }). Once data arrives the reducer
    // replaces it with an array.
    if (!Array.isArray(leads)) return [];

    return leads.map((lead) => {
      const lastTask = lastActivityForLead(lead, tasks) || {};
      const lastActivityDate = lastTask.completedAt;
      const lastActivityType = lastTask.taskType;

      return { ...lead, lastActivityDate, lastActivityType };
    });
  }
);
